import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { withAuthentication } from '@services/auth';
import { PageLoader } from 'junto-ui';

import { ProcessList } from '_/modules/ProcessList/containers';
import { ProcessDetail } from '_/modules/ProcessDetail/containers';
import { Logout } from '_/modules/Logout/containers';
import { responsabilityTerm } from '_/modules/Terms/responsability';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import ClausesList from '../modules/ProcessList/containers/ClausesList';

const Routes = ({ isAuthenticated }) =>
  isAuthenticated ? (
    <Router>
      <Switch>
        <Route path="/" exact component={ProcessList} />
        <Route path="/clauses" exact component={ClausesList} />
        <Route path="/details" component={ProcessDetail} />
        <Route
          path="/terms/termo-de-responsabilidade"
          component={responsabilityTerm}
        />
        <Route path="/logout" component={Logout} />
        <Route
          path="*"
          component={() => {
            window.location.href = getSessionItem('PLATAFORMA_PROCESSOS');
            return null;
          }}
        />
      </Switch>
    </Router>
  ) : (
    <PageLoader style={{ zIndex: 1100 }} />
  );

Routes.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
};

const RoutesWithAuth = withAuthentication(
  Routes,
  window.location.origin,
  process.env.REACT_APP_PLATAFORMA_LOGIN
);

export default RoutesWithAuth;
